<template>
  <ui-sheet v-model="model" sheet-class="rcm-sheet" :title="$t('filters')">
    <div class="rm-sheet__group">
      <h3 class="rm-sheet__label">{{ $t("view") }}</h3>
      <div class="rm-segment" role="group" :aria-label="$t('view')">
        <button
          v-for="v in views"
          :key="v"
          type="button"
          class="rm-segment__btn"
          :class="{ 'is-active': ctl.view === v }"
          :aria-pressed="String(ctl.view === v)"
          @click="ctl.setView(v)"
        >
          {{ ctl.viewLabel(v) }}
        </button>
      </div>
    </div>

    <div v-if="ctl.currentKey === 'meals'" class="rm-sheet__group">
      <h3 class="rm-sheet__label">{{ $t("recipes_shell.order_meals") }}</h3>
      <div class="rm-segment" role="group" :aria-label="$t('recipes_shell.order_meals')">
        <button
          v-for="o in orders"
          :key="o"
          type="button"
          class="rm-segment__btn"
          :class="{ 'is-active': ctl.cardOrder === o }"
          :aria-pressed="String(ctl.cardOrder === o)"
          @click="ctl.setCardOrder(o)"
        >
          {{ $t(`recipes_shell.orders.${o}`) }}
        </button>
      </div>
    </div>

    <div class="rm-sheet__group">
      <div class="rcm-sheet__head">
        <h3 class="rm-sheet__label">{{ $t("recipes_shell.meals_title") }}</h3>
        <span class="rm-muted rm-num">{{ $t("report_mobile.selected_of", { selected: ctl.pickedCount, total: options.length }) }}</span>
      </div>
      <label class="rm-search">
        <v-icon size="18" color="#5f5852">mdi-magnify</v-icon>
        <span class="rm-visually-hidden">{{ $t("recipes_shell.search_meals") }}</span>
        <input v-model="query" type="search" :placeholder="$t('recipes_shell.search_meals')" />
      </label>
      <div class="rcm-sheet__links">
        <button type="button" class="rm-text-btn" @click="ctl.setAllMeals(true)">{{ $t("report_mobile.all") }}</button>
        <button type="button" class="rm-text-btn" @click="ctl.setAllMeals(false)">{{ $t("report_desktop.none") }}</button>
      </div>
      <div class="rcm-checks" role="group" :aria-label="$t('meals')">
        <label v-for="option in visible" :key="option.key" class="rcm-check">
          <input type="checkbox" :checked="ctl.isMealOn(option.key)" @change="ctl.toggleMeal(option.key)" />
          <span>{{ option.label }}</span>
          <em class="rm-num">{{ option.portions ? ctl.fq(option.portions) : $t("recipes_shell.no_portions") }}</em>
        </label>
        <span v-if="!visible.length" class="rm-muted">{{ $t("report_mobile.no_results") }}</span>
      </div>
    </div>

    <div class="rcm-switch">
      <span>
        <b>{{ $t("recipes_shell.prices") }}</b>
        <span class="rm-muted">{{ $t("recipes_shell.prices_hint") }}</span>
      </span>
      <button type="button" class="rcm-sw" role="switch" :aria-checked="String(ctl.price)" :aria-label="$t('recipes_shell.prices')" @click="ctl.togglePrice">
        <i></i>
      </button>
    </div>
    <template #footer>
      <button type="button" class="rm-btn rm-btn--primary" @click="model = false">{{ $t("report_desktop.done") }}</button>
    </template>
  </ui-sheet>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import { matches } from "../recipesLogic";

/** Donji list sa filterima na telefonu: prikaz, redoslijed jela, izbor jela sa pretragom i prekidač za cijene. */
export default {
  name: "RecipesMobileFilterSheet",
  mixins: [hasModel],
  inject: { ctl: "recipesCtl" },
  data: () => ({ query: "", views: ["meal", "group"], orders: ["name", "portions"] }),
  computed: {
    options() {
      return this.ctl.mealOptions;
    },
    visible() {
      return this.options.filter((option) => matches(option.label, this.query));
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.query = "";
      }
    },
  },
};
</script>
